<template>
  <div :style="stickyHeader">
    <header v-if="shownHeaderElement" class="l-the-header">
      <div class="p-the-header">
        <div
          v-if="isExists(shownTopElement)"
          class="p-the-header__header"
          :style="{ borderColor: colorCode }"
        >
          <div
            class="c-common-inner"
            :class="[isWideHeader ? 'p-the-header-inner--admin' : '']"
            ref="lTheHeader"
          >
            <div class="p-the-header__col">
              <div class="p-the-header__primary">
                <!-- タイトルロゴ -->
                <a
                  v-if="isExists('logo')"
                  :href="'/home/'"
                  class="p-the-header__logo"
                  :style="serviceLogoStyle"
                >
                  <img :src="getLogo()" :alt="serviceName" />
                </a>
                <!-- ハンバーガーメニュー（SPの場合のみ表示） -->
                <div
                  v-if="isExists('spNavi')"
                  v-show="isSp"
                  class="p-the-header__menu p-the-header__menu--sp"
                >
                  <TheHeaderNaviForSpLayout
                    ref="spHeaderNavi"
                    :whats-new-unread-count="whatsNewUnreadCount"
                    :thanks-point-unread-count="thanksPointUnreadCount"
                    :switchs-state="switchState"
                    :is-user-admin="isUserAdmin"
                    @click-change-modal-state="showModal()"
                    :point="totalPoints"
                  />
                </div>
              </div>

              <div
                v-if="isExists(shownRightColumn)"
                class="p-the-header__right"
              >
                <div class="p-the-header__right__inner">
                  <div class="p-the-header__right__actions">
                    <!-- マイクーポン -->
                    <a
                      :href="myCouponUrl"
                      class="p-the-header__quick-link p-the-header__quick-link--coupon"
                      :style="{ '--site-color': colorCode }"
                      v-touch:tap
                    >
                      <IconHeaderCoupon
                        class="p-the-header__quick-link__icon"
                      />
                      <span class="p-the-header__quick-link__text"
                        >マイクーポン</span
                      >
                    </a>
                    <!-- お気に入り -->
                    <a
                      :href="favoritesUrl"
                      class="p-the-header__quick-link p-the-header__quick-link--favorite"
                      :style="{ '--site-color': colorCode }"
                      v-touch:tap
                    >
                      <IconHeaderFavorite
                        class="p-the-header__quick-link__icon"
                      />
                      <span class="p-the-header__quick-link__text"
                        >お気に入り</span
                      >
                    </a>
                  </div>

                  <div
                    v-if="showPoint"
                    class="p-the-header__right__point"
                  >
                    <span class="p-the-header__right__point__inner">
                      <!-- ランク（SPの場合のみ表示） -->
                      <IconUserRank
                        v-if="
                          isSp &&
                            isRankDisplayEnabled &&
                            imageResources.rank_image_sp
                        "
                        :size="120"
                        class="p-the-header__right__point__inner__rank"
                      >
                        <img :src="imageResources.rank_image_sp" alt="" />
                      </IconUserRank>
                      <a
                        :href="pointConfirmationUrl"
                        v-touch:tap
                      >
                        <!-- ポイントアイコン、ポイント -->
                        <PointNotation
                          :icon-size="isSp ? 16 : 28"
                          :point="totalPoints"
                          :sign-is-exists="false"
                          :font-size="isSp ? 16 : 24"
                          :point_logo="imageResources.point_logo"
                        />
                      </a>
                    </span>
                  </div>

                  <div class="p-the-header__right__trail">
                    <!-- 「管理に切替」ボタン（PCの場合のみ表示） -->
                    <div
                      v-show="isUserAdmin && !isSp && !ssoFlg"
                      class="p-the-header-navi__switch"
                    >
                      <a
                        @click="showModal()"
                        class="p-the-header-navi__switch__button"
                        :class="[
                          `p-the-header-navi__switch__button--${colorCode}`
                        ]"
                        :style="{
                          background: colorCode,
                          'border-color': colorCode
                        }"
                        v-touch:tap="mouseoverSwitchButton"
                        @mouseover="mouseoverSwitchButton"
                        @mouseleave="mouseoverSwitchButton(false)"
                      >
                        <i class="p-the-header-navi__switch__button__icon">
                          <IconBase
                            :width="22"
                            :height="21"
                            view-box="0 0 22 21"
                            :icon-color="switchButtonSvg"
                          >
                            <IconLoop />
                          </IconBase>
                        </i>
                        <span class="p-the-header-navi__switch__button__text">
                          {{ switchButton.text }}
                        </span>
                      </a>
                    </div>
                    <!-- ユーザーアイコン -->
                    <div
                      v-if="isExists('userMenu')"
                      class="p-the-header__right__user"
                      @click.stop="openHeaderMenu"
                    >
                      <span class="p-the-header__right__user__icon">
                        <IconUserImage :size="36" :is-loading="isLoading">
                          <img v-if="userImage" :src="userImage" :alt="userInfo.name" />
                        </IconUserImage>
                        <span
                          class="
                            p-the-header__right__notification
                            p-the-header__right__notification--profile
                          "
                        >
                          <TextLabelNewArrivalCount
                            v-if="totalUnreadCount > 0 && !isGroupBudget"
                            :count="totalUnread"
                          />
                        </span>
                      </span>
                    </div>
                    <!-- ハンバーガーメニュー（PCの場合のみ表示） -->
                    <div
                      v-if="isExists('userMenu')"
                      v-show="!isSp"
                      class="p-the-header__menu p-the-header__menu--pc"
                    >
                      <TheHeaderUserNavi
                        ref="pcHeaderNavi"
                        :thanks-point-unread-count="thanksPointUnreadCount"
                        :whats-new-unread-count="whatsNewUnreadCount"
                        @logout="logout()"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="p-modal-header">
      <ModalMain v-if="switchState">
        <template v-slot:head
          >管理画面に切り替える際は一度ログアウトします。 <br /><br />
          このページを離れますか？</template
        >
        <template v-slot:body>
          <div class="p-form-button-group">
            <div class="p-form-button-group__buttons-main">
              <div class="p-form-button-group__vertical">
                <ButtonMain
                  type="button"
                  @click-button="handleButtonClick(true)"
                  >OK</ButtonMain
                >
              </div>
              <div class="p-form-button-group__vertical">
                <ButtonMain
                  kind="cancel"
                  @click-button="handleButtonClick(false)"
                  >キャンセル</ButtonMain
                >
              </div>
            </div>
          </div>
        </template>
      </ModalMain>
    </div>
  </div>
</template>

<script lang="ts">
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import TextLabelNewArrivalCount from "@/common/components/atoms/TextLabelNewArrivalCount.vue";

import HeaderMessage from "@/common/components/organisms/header/HeaderMessage.vue";
import TheHeaderNaviForSpLayout from "@/common/components/organisms/header/TheHeaderNaviForSpLayout.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconLoop from "@/common/components/icons/IconLoop.vue";
import IconHeaderCoupon from "@/common/components/icons/IconHeaderCoupon.vue";
import IconHeaderFavorite from "@/common/components/icons/IconHeaderFavorite.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconUserRank from "@/common/components/icons/IconUserRank.vue";
import ModalMain from "@/common/components/organisms/ModalMain.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import TheHeaderUserNavi from "@/common/components/organisms/header/TheHeaderUserNavi.vue";
import commons from "@/common/store/modules/commons";
import store from "@/general/store";
import globals from "@/general/store/modules/globals";
import { Prop, Watch } from "vue-property-decorator";
import { Options, Vue } from 'vue-class-component';
import { SwitchSiteRequest, HeaderInfo } from "@/general/store/models";
import CONST_DATA from "@/general/mixins/const/constData";

import {
  getUserProfileSummary,
  postSwitchSite,
  getHeaderInfo
} from "@/general/store/api";

import { karteUser, karteLogin } from "@/common/assets/js/karte/";
import LocalStorage from "@/general/utils/storage";
import auth from "@/general/store/modules/auth";
import Cookies from "js-cookie";
import loginInfo from "@/general/store/modules/loginInfo";
import AuthApi from "@/general/api/authApi";
import SITE_MAP from "@/general/mixins/const/custom/sitemap";

@Options({
  name: "TheHeader",
  emits: ["user-profile-summary"],
  components: {
    PointNotation,
    TextLabelNewArrivalCount,
    TheHeaderNaviForSpLayout,
    TheHeaderUserNavi,
    HeaderMessage,
    IconBase,
    IconLoop,
    IconHeaderCoupon,
    IconHeaderFavorite,
    IconUserImage,
    IconUserRank,
    ModalMain,
    ButtonMain
  },
  store: store
})
export default class TheHeader extends Vue {
  @Prop({ default: false }) readonly isWideHeader!: boolean;
  @Prop({ type: Boolean, required: false, default: false }) ssoFlg!: boolean;

  serviceLogoStyle: any = {};
  userInfo = commons.userInfo;
  serviceName = commons.serviceName;
  serviceLogo: string | undefined = "";
  thanksPointUnreadCount = 0;
  whatsNewUnreadCount = 0;
  userImage = "";
  isLoading = true;
  point = 0;
  switchButton: any = {};
  switchButtonSvg = "#ffffff";
  totalUnreadCount = 0;
  switchState = false;
  imageResources: any = {};
  userAdmin: string | null = "0";

  declare $refs: {
    lTheHeader: Element;
    spHeaderNavi: TheHeaderNaviForSpLayout;
    pcHeaderNavi: TheHeaderUserNavi;
  };

  /**
   * ユーザーアイコン押下時も、ハンバーガーと同じメニューを開閉する。
   */
  openHeaderMenu() {
    if (this.isSp) {
      this.$refs.spHeaderNavi?.switchShownState();
      return;
    }
    this.$refs.pcHeaderNavi?.switchShownState();
  }

  get colorCode() {
    if(this.isGroupBudget) {
      return '#fc9014'
    }
    return commons?.colorCode;
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get isRankDisplayEnabled(): boolean {
    return commons.userInfo.rankDisplayEnabled === true;
  }

  get grantExclusiveEnabled(): boolean {
    return auth.user?.grant_exclusive_points_enabled;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  getLogo() {
    return this.imageResources["page_logo"];
  }

  get myCouponUrl() {
    return process.env.VUE_APP_MYPAGE + "/coupon?sort=getCouponDatetime";
  }

  get favoritesUrl() {
    return process.env.VUE_APP_MYPAGE + "/favorites/";
  }

  get pointConfirmationUrl() {
    return SITE_MAP.POINT_CONFIRMATION;
  }

  initServiceLogoStyle() {
    //#59042対応によりセッション情報からpage_logoを取得するように修正
    //const serviceLogo: any = commons?.OrgPageSpecific?.page_logo;
    //const serviceLogo: any = commons?.OrgPageSpecific?.page_logo;
    const serviceLogo: any = this.imageResources.page_logo;
    this.serviceLogo = this.imageResources.page_logo;
    
    if (serviceLogo && serviceLogo.width) {

      const rem = 16;
      const maxWidth = serviceLogo.width / rem;

      this.serviceLogoStyle = {
        maxWidth: `${maxWidth}rem`
      };
    }
  }

  get isUserAdmin() {
    return this.userAdmin === "1";
  }

  showModal() {
    this.switchState = true;
  }

  handleButtonClick(flag: boolean) {
    if (flag) {
      this.switchState = false;
      this.switchSite();
      return;
    }
    this.switchState = false;
  }

  async switchSite() {
    const redirectUrl = process.env.VUE_APP_ADMIN_DOMAIN + "/incp/csv-download";
    this.logout(redirectUrl);
  }

  initSwitchButtonObject() {
    const headerInfo = commons.headerInfo;
    const pageType = headerInfo.pageType;
    this.switchButton = headerInfo.switch[pageType];
  }

  mouseoverSwitchButton(mouseover = true) {
    const commonPrimary = this.colorCode?.toString();
    const mouseleave = "#ffffff";

    const resultColor: any = {
      mouseover: commonPrimary,
      mouseleave: mouseleave
    };

    const resultIndex: string = mouseover ? "mouseover" : "mouseleave";

    this.switchButtonSvg = resultColor[resultIndex];
  }

  /**
   * SP画面のときにヘッダーを画面上端へ貼り付ける。
   * fixedと違いヘッダーが自分の高さ分の場所を空けるので、高くなれば下の要素もその分下がる。
   */
  @Watch("switchState")
  get stickyHeader(): any {
    const style = {
      position: "sticky",
      top: "0",
      width: "100%",
      zIndex: "10000"
    };
    if (this.switchState) {
      style.zIndex = "999";
    }

    return this.isSp ? style : "";
  }

  get totalPoints() {
    return this.point;
  }

  get shownHeaderElement() {
    const shownHeaderItem = commons.shownHeaderItem;
    const keyword = /logo|point|searchForm|userMenu|favorite|history|help|switchButton|spNavi|all|logout/;
    if (shownHeaderItem) {
      return shownHeaderItem.some((element: any) => keyword.test(element));
    } else {
      return "all";
    }
  }

  get isExists() {
    return (str: any) => {
      const { shownHeaderItem } = commons.shownHeaderItem;

      const regex = new RegExp(`all|${str}`, "g");

      if (shownHeaderItem) {
        shownHeaderItem.some((element: any) => regex.test(element));
      } else {
        return "all";
      }
    };
  }

  get showPoint(): boolean {
    const USER_ROLES = LocalStorage.getItem("USER_ROLES")
      ? JSON.parse(LocalStorage.getItem("USER_ROLES") as string)
      : [{}];
    const USER_POINTS = LocalStorage.getItem("USER_POINTS")
      ? JSON.parse(LocalStorage.getItem("USER_POINTS") as string)
      : [{}];
    const hasGrantOnlyPoint = USER_POINTS.grant_only_points > 0;
    const isOverManager =
      USER_ROLES.is_master_admin ||
      USER_ROLES.is_group_admin ||
      USER_ROLES.is_manager;
    return (
      (this.isAdminSite && hasGrantOnlyPoint && isOverManager) ||
      !this.isAdminSite
    );
  }

  get shownRightColumn() {
    return "point|searchForm|userMenu";
  }

  get shownTopElement() {
    return "logo|point|searchForm|userMenu";
  }

  get totalUnread() {
    return Number(this.totalUnreadCount ?? 0) >= CONST_DATA.LIMITS.UNREAD_COUNT_DISPLAY_LIMIT
      ? "..."
      : this.totalUnreadCount;
  }

  mounted() {
    if (!this.isAdminSite) {
      karteUser();
    }

    window.onpageshow = function(event: any) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }

  //Lifecycle hook
  async created() {
    commons.setOrgPageSpecificDataFromLocalStorage();
    commons.getCustomData();
    // commons.userInfoの初期化（同メソッド内下部にも同呼び出しがあるが、初期化が間に合わず他画面でサンクスポイント名称を取得できない箇所があったため呼び出しを実行）
    commons.getUserInfo();
    this.ssoFlg = loginInfo.isSso;
    await this.initSwitchButtonObject();

    await AuthApi.getICSession()
    .then((result) => {
        const ic_session = JSON.parse(result);
        this.imageResources = {
          "page_logo": ic_session.pageLogo,
          "point_logo": ic_session.pointLogo,
          "favicon": ic_session.favicon,
          "avatar": ic_session.avatar,
          "rank_image_sp": ic_session.rankImageSp
        }
        LocalStorage.setItem("userIsAdmin", ic_session?.isAdmin);
        this.userAdmin = ic_session?.isAdmin;
        this.userImage = ic_session.avatar;
        this.isLoading = false;
    })
    .catch(() => {
      this.imageResources = {
          "page_logo": "",
          "point_logo": "",
          "favicon": "",
          "avatar": "",
          "rank_image_sp": ""
        }
      this.isLoading = false;
    });

    await this.initServiceLogoStyle();
    
    const link: any = document.querySelectorAll('link[rel="icon"]')[0];
    link.href = this.imageResources.favicon;

    // TODO get point from session redis
    const userPointsDetails = await getUserProfileSummary();

    LocalStorage.setItem(
      "userPointsDetails",
      JSON.stringify(userPointsDetails)
    );
    // ローカルストレージの値が古い場合に画面側が追従できるよう、取得した最新値を親へ通知する
    this.$emit("user-profile-summary", userPointsDetails);
    await commons.getUserPoints();

    const userDetails = JSON.parse(
      LocalStorage.getItem("userDetails") as string
    );
    // commons.userInfoの初期化（同メソッド内上部にも同呼び出しがあるが、非同期処理の都合上こちらでも呼び出しを実行）
    commons.getUserInfo();

    await this.refreshHeaderInfo();
  }

  get isAdminSite() {
    return false;
  }

  async logout(redirectUrl?: string) {
    karteLogin(false);

    let cookieName = "BSJSESSIONID";
    if (process.env.VUE_APP_SESSION_COOKIE_NAME) {
      cookieName = process.env.VUE_APP_SESSION_COOKIE_NAME;
    }
    let cookieDomain = ".benefit-one.inc";
    if (process.env.VUE_APP_COOKIE_DOMAIN) {
      cookieDomain = process.env.VUE_APP_COOKIE_DOMAIN;
    }
    //document.cookie = `${cookieName}=;domain=${cookieDomain};path=/;`;
    Cookies.remove(cookieName);
    await fetch(commons.LOGOUT_URL, { method: "POST" })
      .then(() => {
        window.sessionStorage.clear();
        // window.localStorage.clear();
        LocalStorage.removeAll();
        AuthApi.getLogout().catch((e) => {
          console.log(e);
        });
        auth.remove();
        if (this.ssoFlg) {
          // SSOログインの場合は行き止まりログアウトへ遷移
          window.location.href = "/logout/";
        } else {
          const toTopUrl = process.env.VUE_APP_API_DOMAIN + "/v1/top/login";
          window.location.href = redirectUrl || toTopUrl;
        }
      })
      .catch(() => {
        window.sessionStorage.clear();
        // window.localStorage.clear();
        LocalStorage.removeAll();
        AuthApi.getLogout().catch((e) => {
          console.log(e);
        });
        auth.remove();
        if (this.ssoFlg) {
          // SSOログインの場合は行き止まりログアウトへ遷移
          window.location.href = "/logout/";
        } else {
          const toTopUrl = process.env.VUE_APP_API_DOMAIN + "/v1/top/login";
          window.location.href = redirectUrl || toTopUrl;
        }
      });
  }
  async refreshHeaderInfo() {
    const headerInfo: HeaderInfo = await getHeaderInfo();

    this.thanksPointUnreadCount = headerInfo.thanks_msg_noread_cnt;
    this.whatsNewUnreadCount = headerInfo.whatnew_noread_cnt;
    this.totalUnreadCount = this.thanksPointUnreadCount + this.whatsNewUnreadCount;

    this.point = headerInfo.point;
  }
}
</script>

<style lang="scss" scoped>
.p-the-header {
  background-color: $common-white;
  position: relative;
  z-index: 999;

  &__header {
    @include large-pc {
      min-width: rem($min-width--m);
    }
    @include large-sp {
      min-width: rem($min-width--s);
    }
    border-bottom: {
      width: px(3);
      style: solid;
    }
    position: relative;
  }

  &__col {
    @include large-pc {
      min-height: rem(83);
      padding: rem(16) 0;
      align-items: center;
      justify-content: space-between;
    }
    @include large-sp {
      min-height: rem(96);
      padding: rem(8) 0;
      flex-direction: column;
      align-items: stretch;
      row-gap: rem(8);
    }
    display: flex;
  }

  &__primary {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @include large-sp {
      width: 100%;
    }
  }

  &__logo {
    @include large-pc {
      min-width: rem(280);
      max-width: rem(320);
      max-height: rem(48);
    }
    @include large-sp {
      width: rem(160);
      min-height: rem(24);
      max-height: rem(24);
      flex-grow: 0;
      justify-content: flex-start;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex-grow: 1;

    img {
      @include large-sp {
        max-width: rem(160);
        object-position: left center;
      }
      @include object-fit("contain");
      width: 100%;
      height: 100%;
      display: block;
      object-position: center;
    }
  }

  &__right {
    @include large-pc {
      flex-grow: 1;
    }
    @include large-sp {
      width: 100%;
      min-width: 0;
    }

    &__inner {
      @include large-pc {
        align-items: center;
        gap: rem(16);
        justify-content: flex-end;
      }
      @include large-sp {
        align-items: center;
        width: 100%;
      }
      display: flex;
      height: 100%;
    }

    &__search {
      @include large-pc {
        margin-left: rem(32);
      }
    }

    &__logout {
      @include large-pc {
        margin-left: rem(32);
      }
      @include large-sp {
        margin-left: rem(8);
      }

      &__link {
        @include large-sp {
          width: rem(48);
          height: rem(48);
          display: flex;
          justify-content: center;
          align-items: center;
        }
        @include large-pc {
          display: block;
        }
        position: relative;
      }
    }

    &__user {
      display: block;
      padding-right: 0;
      cursor: pointer;

      @include large-pc {
        margin-left: 0;
      }

      &__icon {
        border-radius: 50%;
        border: px(1) solid $common-gray300;
        display: block;
        position: relative;
      }
    }

    &__actions {
      display: flex;
      align-items: center;
      flex-shrink: 0;

      @include large-pc {
        display: contents;
      }

      @include large-sp {
        gap: rem(8);
        order: 2;
        margin-left: auto;
      }
    }

    &__trail {
      display: flex;
      align-items: center;
      position: relative;
      flex-shrink: 0;

      @include large-pc {
        gap: rem(16);
      }

      @include large-sp {
        gap: rem(8);
        order: 3;
        margin-left: rem(8);
      }

      :deep(.p-the-header-user-navi__list) {
        right: 0;
      }
    }

    &__point {
      flex-shrink: 0;

      @include large-sp {
        order: 1;
        flex-shrink: 1;
        min-width: 0;
      }

      &__inner {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        flex-shrink: 0;

        @include large-sp {
          min-width: 0;
          width: 100%;
        }

        &__rank {
          margin-bottom: rem(2);
        }

        :deep(.p-point-notation) {
          @include large-pc {
            align-items: center;
          }

          @include large-sp {
            min-width: 0;
            width: 100%;
          }
        }

        @include large-sp {
          :deep(.p-point-notation__icon),
          :deep(.p-point-notation__point__num) {
            flex-shrink: 0;
          }

          :deep(.p-point-notation__point) {
            display: flex;
            flex-wrap: wrap;
            align-items: baseline;
            min-width: 0;
            white-space: normal;
          }

          :deep(.p-point-notation__point__unit) {
            white-space: nowrap;
          }
        }
      }
    }
  }

  &__quick-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    color: var(--site-color);

    &:hover :deep(.p-icon-header-favorite__shape),
    &.tap :deep(.p-icon-header-favorite__shape) {
      fill: currentColor;
    }

    &:hover :deep(.p-icon-header-coupon__fill),
    &.tap :deep(.p-icon-header-coupon__fill),
    &:hover :deep(.p-icon-header-coupon__dash),
    &.tap :deep(.p-icon-header-coupon__dash) {
      opacity: 1;
    }

    &:hover :deep(.p-icon-header-coupon__separator),
    &.tap :deep(.p-icon-header-coupon__separator) {
      fill: $common-white;
    }

    &__icon {
      width: rem(36);
      height: rem(36);
      object-fit: contain;
      transition: color $transition-sec--fast ease-in;

      @include large-sp {
        width: rem(24);
        height: rem(24);
      }
    }

    &__text {
      color: $common-black;
      font-family: 'Noto Sans JP';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 100%;
      display: flex;
      align-items: center;
      text-align: center;
      font-feature-settings: 'palt' on, 'pwid' on;
      white-space: nowrap;
    }
  }

  &__menu {
    flex-shrink: 0;

    &--pc {
      width: rem(36);
      height: rem(36);
    }

    &--sp {
      width: rem(36);
      height: rem(36);

      :deep(.p-the-header-navi-for-sp-layout__button) {
        width: rem(36);
        height: rem(36);
      }
    }
  }
}

.p-the-header-inner {
  &--admin {
    @include large-pc {
      max-width: initial;
    }
  }
}

.p-the-header-navi {
  &__switch {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 0;

    &__button {
      min-width: rem(106);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: rem(4);
      border: {
        width: px(1);
        style: solid;
        color: $common-primary;
      }
      padding: rem(4) rem(8);
      transition: all $transition-sec--fast ease-in;

      &--sub {
        background-color: $common-black-sub;
        background-color: $common-black-sub;
      }

      &--sub.tap &__text {
        color: $common-black-sub;
      }

      &--primary {
        background-color: $common-primary;
        border-color: $common-primary;
      }

      &--primary.tap &__text {
        color: $common-primary;
      }

      &--blue {
        background-color: $customize-blue;
        border-color: $customize-blue;
      }

      &--blue.tap &__text {
        color: $customize-blue;
      }

      &--green {
        background-color: $customize-green;
        border-color: $customize-green;
      }

      &--green.tap &__text {
        color: $customize-green;
      }

      &--yellow {
        background-color: $customize-yellow;
        border-color: $customize-yellow;
      }

      &--yellow.tap &__text {
        color: $customize-yellow;
      }

      &--pink {
        background-color: $customize-pink;
        border-color: $customize-pink;
      }

      &--pink.tap &__text {
        color: $customize-pink;
      }

      &.tap {
        background-color: #ffffff;
      }

      &.tap &__icon {
        transform: rotate(-45deg);
      }

      &__icon {
        display: flex;
        align-items: center;
        transition: all $transition-sec--fast ease-in;
      }

      &__text {
        font-weight: bold;
        font-size: rem(14);
        color: #ffffff;
        line-height: 1.6;
        transition: all $transition-sec--fast ease-in;
      }
    }
  }
}
</style>
<style lang="scss">
.p-the-header {
  &__right {
    &__notification {
      @include large-pc {
        right: rem(-3);
        top: rem(-5);
      }
      position: absolute;
      width: rem(16);
      height: rem(16);
      display: block;

      &--profile {
        right: rem(-6);
        top: rem(-1);
      }
    }
  }
}
.p-modal-header .p-modal-main {
  &__content {
    padding: 1.5rem 1rem !important;
    width: 100% !important;
    max-width: 25rem;
  }
  &__scrollable {
    overflow-y: auto !important;
  }
}
</style>
